exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".paypal[data-v-452e94e4] {\n  background-color: #ffc439;\n  color: white;\n  height: 54px;\n  line-height: 54px;\n  border-radius: 5px;\n  margin-top: 15px;\n  cursor: pointer;\n}\n.paypal[data-v-452e94e4]:hover {\n  background-color: #f2ba36;\n}\n.paypal .img1[data-v-452e94e4] {\n  width: 18px;\n  height: 24px;\n}\n.paypal .img2[data-v-452e94e4] {\n  width: 75px;\n  height: 24px;\n}", ""]);

// exports
